import { useState } from 'react'
import axios from 'axios';
import { FormRow, Alert } from './components'
import { useAppContext } from './context/appContext'


const Profile = () => {
  const { user, showAlert, displayAlert, displayAlertText, updateUser, isLoading } =
    useAppContext()

  const [name, setName] = useState(user?.name)
  const [gender, setGender] = useState(user?.gender)
  const [filePath, setFilePath] = useState(user?.filePath)

  const [uploadFileName, setUploadFileName] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!name) {
      displayAlert()
      return
    }
    updateUser({ name, gender })
  }

  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleFileUpload = () => {
    console.log('Upload file: ' + selectedFile.name);
    setUploadFileName('Upload file: ' + selectedFile.name);
    /*
    const formData = new FormData();
    formData.append('profileImage', selectedFile);
    formData.append('userId', user._id)

    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
    axios.post(`${API_URL}/users/profile-image-upload`, formData)
      .then((response) => {
        console.log(response.data);
        // Handle successful file upload
        window.location.reload(false);
      })
      .catch((error) => {
        console.error('Error uploading file:', error);
        // Handle file upload error
      });
      */
  };

  return (
    <>
      { uploadFileName !== '' && <div className={`alert alert-info`}>{uploadFileName}</div> }
      {/* <img src={filePath} alt="Image" /><br/> */}
      <input type="file" onChange={handleFileChange} />
      <button onClick={handleFileUpload}>Upload</button>
      <hr></hr>
      <form className='form' onSubmit={handleSubmit}>
        <h3>profile</h3>
        {showAlert && <Alert />}
        <div className='form-center'>
          <FormRow
            type='text'
            name='name'
            value={name}
            handleChange={(e) => setName(e.target.value)}
          />
          <div className='form-row'>
            <label htmlFor='gender' className='form-label'>
              Gender
            </label>
            
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Male"
                  checked={gender === "Male"}
                  onChange={(e) => setGender(e.target.value)}
                  data-testid='male'
                />
                &nbsp;&nbsp;Male
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Female"
                  checked={gender === "Female"}
                  onChange={(e) => setGender(e.target.value)}
                  data-testid='female'
                />
                &nbsp;&nbsp;Female
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  name="gender"
                  type="radio"
                  value="Other"
                  checked={gender === "Other"}
                  onChange={(e) => setGender(e.target.value)}
                  data-testid='other'
                />
                &nbsp;&nbsp;Other
              </label>
            </div>
          </div>
          <button className='btn btn-block' type='submit' disabled={isLoading}>
            {isLoading ? 'Please Wait...' : 'save changes'}
          </button>
        </div>
      </form>
    </>
  )
}

export default Profile
